module.exports = "<app-loading-screen [loading]=\"loading\"></app-loading-screen>\n<app-home [loading]=\"loading\"></app-home>"